import Progress   from '@material-ui/core/LinearProgress';
import withStyles from '@material-ui/core/styles/withStyles';

export default withStyles(() => ({
	root: {
		width: '100%',
		height: 10,
	},
}))(Progress);
